<wdpr-checkbox
    #wdprCheckbox
    class="checkbox"
    [id]="id"
    [checked]="checked"
    [attr.disabled]="disabled"
    (checked-changed)="onCheckChanged($event)"
    (keydown)="onKeyDown($event)"
    (click)="onClick($event)"
    >
    <ng-content></ng-content>
</wdpr-checkbox>
